import { elements } from '#components/generics/js/styles.js'
import * as utilities from '#utilities/js/styles.js'
import capture from '@mailobj-browser/front/js/events/options/capture.js'
import click from '@mailobj-browser/front/js/events/types/click.js'
import all from '@mailobj-browser/front/js/selectors/all.js'
import closest from '@mailobj-browser/front/js/selectors/closest.js'
import one from '@mailobj-browser/front/js/selectors/one.js'
import passive from '@mailobj-browser/front/js/events/options/passive.js'
import listener from '@mailobj-browser/front/js/events/listeners/listener.js'
import removed from '@mailobj-browser/front/js/tree/removed.js'
import object from '@mailobj-browser/front/js/utils/object.js'
import { displayCounter } from '#components/generics/js/elementCounter/displayCounter.js'
import { events, manageChildren } from '#components/generics/js/childHideable/container.js'
import { scope } from '#components/generics/js/selectors/scope.js'

const childHideableContainers = new WeakMap()
const containers = new WeakMap()

const onChildHideableReady = object(listener, {
  type: events.ready,
  passive,
  task: childHideableContainer => {
    const { ownerDocument } = childHideableContainer
    const nestedChildHideableContainers = childHideableContainers.get(ownerDocument)

    for (const childHideableContainers of nestedChildHideableContainers) {
      if (!ownerDocument.contains(childHideableContainers)) {
        nestedChildHideableContainers.delete(childHideableContainers)

        break
      }
      const { container } = containers.get(childHideableContainers)
      const button = one(`.${elements.collapse_button}`, container)

      displayCounter(container)
      onClick.listen(button)
    }
  }
})

const onClick = object(listener, {
  type: click,
  passive,
  capture,
  task: button => {
    const container = closest(`.${elements.list_expandable}`, button)
    const actions = all(`[data-scope-json].${utilities.modifiers.display.none}`, container)

    if (actions.length) {
      for (const action of actions) {
        const { child_hideable_name } = scope(action)

        if (child_hideable_name) {
          action.classList.remove(utilities.modifiers.display.none)
        }
      }

      container.classList.remove(utilities.modifiers.display.flex)
    } else {
      const childHideablesContainer = one(`[data-contract='childHideable.container']`, container)

      manageChildren(childHideablesContainer)
      container.classList.add(utilities.modifiers.display.flex)
    }
  }
})

export default container => {
  const { ownerDocument } = container
  const { dataset } = container
  const { listExpandableUid } = dataset

  if (listExpandableUid) {
    queueMicrotask(async () => {
      if (!childHideableContainers.has(ownerDocument)) {
        childHideableContainers.set(ownerDocument, new Set())
      }

      const childHideableContainer = one(`[data-contract='childHideable.container']`, container)
      const nestedChildHideableContainers = childHideableContainers.get(ownerDocument)

      nestedChildHideableContainers.add(childHideableContainer)
      containers.set(childHideableContainer, { container })
      onChildHideableReady.listen(childHideableContainer)
      await removed(childHideableContainer)
      nestedChildHideableContainers.delete(childHideableContainer)
      containers.remove(childHideableContainer)
    })
  }
}
